import { OktaIconUrl } from "@p0security/shared/integrations/constants";
import { OktaComponents } from "@p0security/shared/integrations/directories/okta/components";
import { Typography } from "antd";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { oktaInstaller } from "./install";

const OktaPreamble = (
  <>
    <Typography.Paragraph>
      Connect Okta to manage user access through directory groups and enable
      SAML federation for AWS access provisioning.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>
        Administrative access to Okta (<code>Super Administrator</code> or{" "}
        <code>Application Administrator</code> role)
      </li>
    </ul>
  </>
);

export const Okta = (
  props: Pick<InstallProps<typeof OktaComponents>, "cardOverride" | "onInstall">
) => {
  const itemKind = useCallback(() => "directory", []);
  return (
    <Install<typeof OktaComponents>
      components={OktaComponents}
      installer={oktaInstaller}
      integration="okta"
      itemKind={itemKind}
      logo={OktaIconUrl}
      preamble={OktaPreamble}
      title={"Okta"}
      {...props}
    />
  );
};
